import { api } from "@services/baseURL";

export const SaveAmostra = async (idSolicitacaoProcessoItem, data) => {
  try {
    const response = await api.post(
      `Amostra/${idSolicitacaoProcessoItem}`, data);
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar amostra:', error);
    throw error;
  }
};

export const UpdateAmostra = async (idAmostra, data) => {
  try {
    const response = await api.patch(
      `Amostra/${idAmostra}`, data);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar amostra:', error);
    throw error;
  }
};

export const DeleteAmostra = async (id) => {
  try {
    await api.delete(`Amostra/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar amostra:', error);
    throw error;
  }
};

export const GetAllAmostras = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('Amostra', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todas amostras:', error);
    throw error;
  }
};

export const GetByIdAmostra = async (id) => {
  try {
    const response = await api.get(`Amostra/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar amostra:', error);
    throw error;
  }
};

export default {
  SaveAmostra,
  DeleteAmostra,
  GetByIdAmostra,
  GetAllAmostras
};